import UpdateBasketRequestModelBase from '../_generated/modelBases/update-basket-request-model-base';

export default class UpdateBasketRequestModel extends UpdateBasketRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
